import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";
import parakeetPlaceholder from "../assets/parakeet_1.png"; // Add an image placeholder for the mascot
import parakeetLogo from "../assets/parakeet_logo_1.png"; // Add an image placeholder for the mascot

const Home = () => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate("/login");
  };

  const navigateToSignup = () => {
    navigate("/signup");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        position: "relative", 
        overflow: "hidden",
        color: "white",
        padding: 3,
        background: "linear-gradient(145deg, #1a1a1a, #2c2f36)", // Darker gradient for high contrast
      }}
    >
      {/* Background animation */}
      <div className="background-gradient" style={{
        position: "absolute", 
        top: 0, 
        left: 0, 
        width: "100%", 
        height: "100%",
        background: "linear-gradient(45deg, #202020, #333333, #4a4a4a)", // Darker gradient
        backgroundSize: "200% 200%", 
        animation: "gradientAnimation 8s ease infinite",
        zIndex: -1,
      }} />

      {/* Mascot */}
      <img
        src={parakeetLogo}
        alt="Parakeet Mascot"
        style={{
          width: "160px",  // Adjusted size for better balance
          marginBottom: "20px",
          borderRadius: "50%",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          transition: "transform 0.3s ease-in-out",
        }}
        onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
      />

      {/* Brand Name */}
      <Typography
        variant="h3"
        gutterBottom
        sx={{
          fontWeight: "bold",
          marginBottom: "16px",
          fontFamily: "'Poppins', sans-serif", 
          color: "#ffffff", // Lightened font color
          fontSize: { xs: "2rem", sm: "3rem" }, // Responsive font size
        }}
      >
        Datakeet
      </Typography>

      {/* Tagline */}
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: "#b0b0b0", // Lighter color for tagline
          maxWidth: "600px",
          fontSize: { xs: "1rem", sm: "1.2rem" }, // Responsive font size
          marginBottom: "24px",
          fontFamily: "'Roboto', sans-serif",
        }}
      >
        Empower your brand with AI-driven insights. Let our friendly parakeet
  help you make better use of your data.
      </Typography>

      {/* Login & Signup Buttons */}
      <Stack direction="row" spacing={3} sx={{ marginTop: 4 }}>
        <Button
          variant="contained"
          size="large"
          onClick={navigateToLogin}
          sx={{
            paddingX: 5,
            fontSize: "1rem",
            borderRadius: "50px",
            backgroundColor: "#009688", // Teal for button color
            color: "white",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            "&:hover": {
              backgroundColor: "#00796b", // Darker teal for hover
            },
          }}
        >
          Login
        </Button>

        <Button
          variant="outlined"
          size="large"
          onClick={navigateToSignup}
          sx={{
            paddingX: 5,
            fontSize: "1rem",
            borderRadius: "50px",
            borderColor: "#009688", // Match button color
            color: "#009688",
            "&:hover": {
              backgroundColor: "rgba(0, 150, 136, 0.1)",
              borderColor: "#00796b",
              color: "#00796b",
            },
          }}
        >
          Signup
        </Button>
      </Stack>
    </Box>
  );
};

export default Home;
